/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TabView, TabPanel } from 'primereact/tabview';
import { FilterMatchMode } from 'primereact/api';
import { PERMISSION } from '../../../constants';
import Utils from '../../../utils/utils';
import { user } from '../../../redux/user';
import WithOnlyOnDesktop from '../../../components/onlyOnDesktop/withOnlyOnDesktop';
import { useAgencyContactsQuery } from '../../../redux/external-agency';
import { showNotification } from '../../../redux/notification';
import AgencyContactsList from './AgencyContactsList';
import AddContactModal from './AddContactModal';

import '../AgencyScreen.scss';
import './AgencyContacts.scss';

const AgencyContacts = () => {
	const userData = useSelector(user);
	const [searchTerm, setSearchTerm] = useState('');
	const [searchFilter, setSearchFilter] = useState({ global: { value: null, matchMode: FilterMatchMode.CONTAINS } });
	const [showContactModal, setShowContactModal] = useState(false);
	const [selectedContact, setSelectedContact] = useState({});

	const { data: contacts } = useAgencyContactsQuery(null, { refetchOnMountOrArgChange: true });
	const dispatch = useDispatch();
	const _showNotification = (type, message) => dispatch(showNotification(type, message));
	const hasContactsCreatePermission = Utils.isAuthorizedExact(PERMISSION.AGENCY.CONTACTS_CREATE, userData.permissions);
	const hasContactsEditPermission = Utils.isAuthorizedExact(PERMISSION.AGENCY.CONTACTS_EDIT, userData.permissions);
	const hasContactsChangeStatusPermission = Utils.isAuthorizedExact(
		PERMISSION.AGENCY.CHANGE_STATUS,
		userData.permissions
	);

	const onSearchTermUpdate = (e) => {
		const newValue = e.target.value;
		setSearchTerm(newValue);
		const _filter = { ...searchFilter };
		_filter.global.value = newValue;
		setSearchFilter(_filter);
	};
	const clearSearch = () => {
		setSearchTerm('');
		setSearchFilter({ global: { value: null, matchMode: FilterMatchMode.CONTAINS } });
	};

	const handleAddContact = () => setShowContactModal(true);
	const handleCancelAddContact = () => {
		setShowContactModal(false);
		setSelectedContact({});
	};

	const handleEditContact = (_contact) => {
		setShowContactModal(true);
		setSelectedContact(_contact);
	};

	const handleSaveContact = () => handleCancelAddContact();

	return (
		<WithOnlyOnDesktop>
			<div className="external-agency-screen external-agency-contacts">
				<div className="d-flex align-items-center">
					<div className="title flex-one">My Team</div>
					<span className="global-search-container">
						<input
							type="text"
							value={searchTerm}
							onChange={onSearchTermUpdate}
							placeholder="Search for contact, email, phone, and more"
						/>
						{searchTerm && <span className="clear-icon" role="img" aria-label="Clear" onClick={clearSearch} />}
					</span>
				</div>
				<TabView>
					<TabPanel header="All">
						<div className="contacts-count-wrapper">
							<div className="contacts-count">{contacts?.length > 0 && `${contacts.length} contacts`}</div>
							{hasContactsCreatePermission && (
								<button type="button" className="add-contact-button" onClick={handleAddContact}>
									+ Add contact
								</button>
							)}
						</div>
						<AgencyContactsList
							contacts={contacts}
							searchFilter={searchFilter}
							hasContactsEditPermission={hasContactsEditPermission}
							onEditContact={handleEditContact}
						/>
					</TabPanel>
				</TabView>
			</div>

			{showContactModal && (
				<AddContactModal
					userData={userData}
					contact={selectedContact}
					onCancel={handleCancelAddContact}
					onSaveSuccess={handleSaveContact}
					showNotification={_showNotification}
					hasContactsChangeStatusPermission={hasContactsChangeStatusPermission}
				/>
			)}
		</WithOnlyOnDesktop>
	);
};

export default AgencyContacts;
